class Form {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-job-form="scope"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $scope = $(element);
			$scope.find('[name^="vacature-pagina-"]').val(window.location.href.split('?')[0]);
            $scope.find('[type="file"]').attr('accept', '.pdf,.docx,.doc,.odt,.rtf,.txt,.jpg,.jpeg,.png,.bmp,.webp');

            // Add vacature id if exists.
            let vacatureId = $('[data-vacature-id]').data('vacature-id');
            if (typeof vacatureId !== "undefined") {
                $scope.find('[name^="vacatureid-"]').val(vacatureId);
            }
        })
	}
}

export default new Form;
